<template>
  <div class="pt-3">
    POR FAZER
  </div>
</template>

<script>
  import {axiosInstance} from '../../axios-auth'

  export default {
    data() {
      return {
        //
      }
    },
    name: "WorkspaceSettings",
    methods: {
      //
    },

  }
</script>




// WEBPACK FOOTER //
// src/components/workspace/WorkspaceSettings.vue